import { serviceName } from '../resources/serviceConstants';
import { CSAT_HISTORY_UPDATE, CSAT_HISTORY_DELETE } from '../resources/endPoint';

const buildProjectRequest = (url, method = 'get', payload) => ({
  url,
  method,
  headers: {
    'Content-Type': 'application/json',
  },
  authRequired: false,
  csrfToken: true,
  ...(payload !== undefined ? { payload } : {}),
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const updateProjectCsat = (csatId, payload) => buildProjectRequest(
  `${CSAT_HISTORY_UPDATE}/${csatId}`,
  'put',
  payload,
);

export const deleteProjectCsat = (csatId) => buildProjectRequest(
  `${CSAT_HISTORY_DELETE}/${csatId}`,
  'delete',
);
